module.exports = __webpack_public_path__ + "img/docs_white.02d9e49b.svg";